// $(window).keyup(function(e){
//   if(e.keyCode == 9){
//     if($('.wcagLink').hasClass('hidden')){
//       $('.wcagLink').css('opacity', 1);
//       $('.wcagLink').show();
//       $('.wcagLink').removeClass('hidden');
//     }
//   }
// })

$('.wcagLink a').click(function(e){
  e.preventDefault();

  let skipLink = $(this).data('open');
  SKIPTODATA(skipLink);
});
function closeSkip(){
  $('.wcagLink').css('opacity', 0);
  $('.wcagLink').hide();

  $('.wcagLink').addClass('hidden');
}

const SKIPTODATA = (data) => {
  switch(data){
    case 'nav':
      $('[data-function="menu"]').focus();
      closeSkip();
      break;		
  }
}